import { connect } from 'react-redux';
import Container from './Container';
import { storeName } from './reducer';
import { convertFromImmutableToJS } from '../../helpers/common';
import { getAboutPageData as loadAboutPageData } from './actions';

const mapStateToProps = (state) => {
  return convertFromImmutableToJS(state.get(storeName));
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAboutPageData: () => {
      dispatch(loadAboutPageData());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
